import AuthFormPolicyDisclaimer from '@components/AuthForm/components/AuthFormPolicyDisclaimer';
import { OldInput, Picture } from '@ui';
import { observer } from 'mobx-react';
import type { FC, FormEventHandler, KeyboardEvent, MouseEvent } from 'react';
import { useState } from 'react';
import { barMenuAuthImage } from '@images';
import AuthFormBtn from '@components/AuthForm/components/AuthFormBtn';
import { twcls } from '@utils/twcls';
// import { Link, useParams } from '@compat/router';

const BAR_MENU_SUCCESS_BTN__CLS =
  'flex flex-1 items-center justify-center h-12 px-2 text-sm leading-[1.2] bg-transparent border border-solid rounded-lg cursor-pointer disabled:cursor-default disabled:opacity-50';

interface BarMenuMainProps {
  setInputData: (data: { value: string; error?: string }) => void;
  handleKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  formData: { text: { value: string; error?: string } };
  onRegisterByEmailClickHandler;
  userExists: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
  onBtnClickHandler?: (e: MouseEvent | KeyboardEvent<HTMLInputElement>) => void;
  onTelegramClick?: () => void;
  onMaxClick?: () => void;
  compact?: boolean;
  onLoginOrRegisterError?: string;
}

const BarMenuMain: FC<BarMenuMainProps> = ({
  setInputData,
  handleKeyDown,
  formData,
  onRegisterByEmailClickHandler,
  userExists,
  onSubmit,
  onBtnClickHandler,
  onTelegramClick,
  onMaxClick,
  compact,
  onLoginOrRegisterError
}) => {
  // const { barId, tableId } = useParams<{
  //   tableId: string;
  //   barId: string;
  // }>();
  const [isPhoneInputVisible] = useState(() => !formData.text.value);

  if (compact) {
    return (
      <div className='w-full'>
        <form autoComplete='on' onSubmit={onSubmit}>
          <h2 className='mb-2 text-base font-medium leading-5'>
            Войдите в личный кабинет чтобы видеть статус заказа
          </h2>
          <div
            className={twcls(
              !isPhoneInputVisible &&
                'absolute invisible w-0 h-0 overflow-hidden'
            )}
            aria-hidden={!isPhoneInputVisible}
          >
            <OldInput
              className='mb-4 text-center'
              placeholder={'Телефон'}
              getInputData={setInputData}
              field={'phone'}
              value={formData.text.value}
              error={formData.text.error}
              name='phone'
              onKeyDown={handleKeyDown}
              autoComplete='tel'
              inputClassName='!text-base'
            />
          </div>
          {isPhoneInputVisible && (
            <div className='mb-4'>
              <AuthFormPolicyDisclaimer
                btnTitle={'Код по звонку'}
                className='text-xs text-left [&>br]:hidden'
                isBarMenu
              />
            </div>
          )}
          {(onLoginOrRegisterError ||
            (!isPhoneInputVisible && formData.text.error)) && (
            <p className='mb-2 text-sm text-[var(--dark-red)]'>
              {onLoginOrRegisterError || formData.text.error}
            </p>
          )}

          <div className='flex gap-2'>
            <button
              type='button'
              disabled={Number(formData?.text?.value?.length) === 0}
              className={BAR_MENU_SUCCESS_BTN__CLS}
              onClick={onBtnClickHandler}
            >
              Код по звонку
            </button>
            <button
              type='button'
              disabled={Number(formData?.text?.value?.length) === 0}
              className={BAR_MENU_SUCCESS_BTN__CLS}
              onClick={onTelegramClick}
            >
              Код в Telegram
            </button>
          </div>
          <AuthFormBtn
            type='button'
            className='mb-0 mt-3'
            onClick={onMaxClick}
          >
            Код в MAX
          </AuthFormBtn>
        </form>
      </div>
    );
  }

  return (
    <div className='w-full h-full'>
      <div className='-mx-3 '>
        <Picture
          icon={barMenuAuthImage}
          className='w-full h-auto'
          width='375'
          height='236'
        />
      </div>
      <form className='py-4' autoComplete='on' onSubmit={onSubmit}>
        <h1 className='mb-4 text-2xl font-medium'>
          Пожалуйста, <br />
          укажите номер телефона
        </h1>
        <ul className='text-[var(--ultra-dark-grey)] mb-8'>
          {[
            'для начисления бонусов и скидок',
            'просмотра онлайн меню и отзывов',
            'онлайн оформления и оплаты заказа'
          ].map((item, index) => (
            <li key={index} className='list-disc list-inside'>
              {item}
            </li>
          ))}
        </ul>
        <OldInput
          className='mb-4 text-center'
          placeholder={'Телефон'}
          getInputData={setInputData}
          field={'phone'}
          value={formData.text.value}
          error={formData.text.error}
          name='phone'
          onKeyDown={handleKeyDown}
          autoComplete='tel'
          autoFocus
          inputClassName='!text-base'
        />
        <div className='mb-8'>
          <AuthFormPolicyDisclaimer
            btnTitle={'Далее'}
            className='text-xs text-left [&>br]:hidden'
            isBarMenu
          />
        </div>
        {onLoginOrRegisterError && (
          <p className='mb-3 text-sm text-[var(--dark-red)]'>
            {onLoginOrRegisterError}
          </p>
        )}
        <div className=''>
          {!userExists && (
            <AuthFormBtn
              disabled={Number(formData?.text?.value?.length) === 0}
              onClick={onRegisterByEmailClickHandler}
              className='AuthFormBtn--grey'
            >
              Регистрация
            </AuthFormBtn>
          )}
          {userExists && (
            <>
              <AuthFormBtn
                type='button'
                disabled={Number(formData?.text?.value?.length) === 0}
                className={twcls('sm:mb-3')}
                onClick={onBtnClickHandler}
              >
                Код по звонку
              </AuthFormBtn>
              <AuthFormBtn
                type='button'
                disabled={Number(formData?.text?.value?.length) === 0}
                className={twcls('sm:mb-3')}
                style={{ background: '#68B9F3', color: '#fff' }}
                onClick={onTelegramClick}
              >
                Код в Telegram
              </AuthFormBtn>
            </>
          )}
          <AuthFormBtn type='button' onClick={onMaxClick}>
            Код в MAX
          </AuthFormBtn>
          {/* <Link
            to={`/bar-menu/${barId}/${tableId}/menu`}
            className='flex items-center justify-center w-full py-4 mb-2 text-sm bg-white border border-solid rounded-lg'
          >
            Посмотреть меню без регистрации
          </Link> */}
          <p className='text-[var(--ultra-dark-grey)] text-center text-xs'>
            Оформить заказ можно на баре
          </p>
        </div>
      </form>
    </div>
  );
};

export default observer(BarMenuMain);
